import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import axios from 'axios';
import getMetaTagData from '../../../../src/common/services/getMetaTagData';

import { getSectionDataApiUrl } from '../../../../src/common/utils/tvUtil';
import { SECTION_LIST_PAGE_LIMIT } from '../../../../src/common/constants/number';
import { toFit } from '../../../../src/hooks/useToFit';
import SliderWithTitle from '../../../../src/component/pc/carousel/SliderWithTitle';

export default function Theme () {
  const router = useRouter();
  const { pageSection: section, category = '', sort = '' } = router.query;
  const [pageQueryParams, setPageQueryParams] = useState({ section, category, sort, offset: 0, limit: SECTION_LIST_PAGE_LIMIT });
  const [sectionDataList, setSectionDataList] = useState([]);
  const [sectionDataIsLoading, setSectionDataIsLoading] = useState(false); // 로딩바 띄우는 컴포넌트 체킹

  useEffect(() => {
    window.document.addEventListener('scroll', toFit(doNextPage, {}));

    function doNextPage () {
      if ((window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight) {
        setPageQueryParams(prev => {
          const nextOffset = prev.offset + prev.limit;
          let sectionDataListLength;
          setSectionDataList(sPrev => {
            sectionDataListLength = sPrev.length;
            return sPrev;
          });

          if (sectionDataListLength === nextOffset) {
            prev.offset = nextOffset;
            return { ...prev };
          } else {
            return prev;
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    const config = {
      method: 'get',
      url: process.env.NEXT_PUBLIC_API_THEME_TV,
      timeout: 3000
    };

    setSectionDataIsLoading(true);

    axios(config)
      .then(function (response) {
        const addList = [];

        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];

          // contents:(20) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
          // list_code:'10000000525'
          // ord_no:'1'
          // pgm_nm:'[이벤트]놓치지마세요! 딱 한달만 초고화질 무료'
          // title:'[이벤트]놓치지마세요! 딱 한달만 초고화질 무료'
          // title_view_yn:'Y'

          // contents: ==========================================================================>
          // 0:{
          // pgm_nm: '달의 연인-보보경심 려',
          // link_url: 'http://programs.sbs.co.kr/drama/scarletheart',
          // pgm_img_url: 'http://img2.sbs.co.kr/600img/22000009610_600x847.jpg',
          // m_img_url: 'http://img2.sbs.co.kr/600img/22000009610_600x847.jpg',
          // playtime: null
          // content_num:null
          // img_alt:'달의 연인-보보경심 려'
          // isfree:false
          // link_new_yn:'N'
          // link_url:'http://programs.sbs.co.kr/drama/scarletheart'
          // m_img_url:'http://img2.sbs.co.kr/600img/22000009610_600x847.jpg'
          // pgm_img_url:'http://img2.sbs.co.kr/600img/22000009610_600x847.jpg'
          // pgm_nm:'달의 연인-보보경심 려'
          // playtime:null
          // srs_dtl_no:null
          // srs_no:null
          // target_age:0
          // type:'P'

          const item = {
            key: i,
            slide_key: i,
            title: element.title,
            desc: '',
            link: '',
            type: 'poster',
            data: element.contents,
            info: { title: element.pgm_nm },
            ord_no: element.ord_no,
            label: [],
            contents: element.contents,
            list_code: element.list_code
          };

          addList.push(item);
        }

        if (addList.length > 0) {
          setSectionDataList(addList); // 최종적으로 통신에서 불러온 데이터를 list 에서 담는 부분
        } else {
          setSectionDataList([]);
        }
      }).catch(function (error) {
        //console.log(error);
      }).finally(() => {
        setSectionDataIsLoading(false);
      });
  }, [pageQueryParams]);

  return (
    <div>
      {/* 테마일때만 */}
      {sectionDataList.filter(x => Array.isArray(x.contens) || Array.isArray(x.contents)).map((item, index) => {
        return (
          <SliderWithTitle
            key={index}
            slide_key={index}
            title={item.title}
            desc={item.desc}
            link={item.link}
            type='poster'
            data={item.data}
            relate_id={item.relate_id}
            relate_title={item.relate_title}
            relate_title_view_yn={item.relate_title_view_yn}
            relate_type={item.relate_type}
            bottom_type={item.bottom_type}
            ord_no={item.ord_no}
            clickParams={'div=' + 'tv_total_theme_' + item.list_code}
          />
        );
      })}
    </div>
  );
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const defaultMetaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  const tvSectionTopList = await getTvSectionTopList(pageSection, pageCategory);

  if (Array.isArray(tvSectionTopList?.data) && tvSectionTopList.data.length > 0) {
    const topProgramTitleList = tvSectionTopList.data.map(item => item.pgm_nm);
    if (defaultMetaTagData.keywords) {
      defaultMetaTagData.keywords = defaultMetaTagData.keywords + ',' + topProgramTitleList.toString();
    } else {
      defaultMetaTagData.keywords = topProgramTitleList.toString();
    }
  }

  return { props: { defaultMetaTagData } };
}

async function getTvSectionTopList (sectionCode, categoryCode) {
  const sectionDataApiUrl = getSectionDataApiUrl(0, 'top', sectionCode, categoryCode, 20);
  const config = {
    method: 'get',
    url: sectionDataApiUrl.href,
    timeout: 3000
  };

  return axios(config)
    .catch(function (error) {
      //console.log(error);
    });
}
